import React from 'react';
import PropTypes from 'prop-types';
import FormWrapper from '../../components/form-wrapper';

class SigninForm extends React.Component {
  constructor(props) {
    super(props);
    this.formConfig = [
      {
        label: 'E-mail',
        name: 'email',
        type: 'email',
        placeholder: 'E-mail',
        initialValue: '',
      },
      {
        label: 'Password',
        name: 'password',
        type: 'password',
        placeholder: 'Password',
        initialValue: '',
      },
    ];
  }
  render() {
    return (
      <FormWrapper
        config={this.formConfig}
        onValidSave={this.props.onSave}
        onCancel={this.props.onCancel}
        submitButtonLabel="Login"
        cancelButtonLabel="Voglio iscrivermi"
      />
    );
  }
}

SigninForm.propTypes = {
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default SigninForm;



// WEBPACK FOOTER //
// ./src/containers/user/signin-form.js